<template>
  <div class="dropdown">
<!--    <input type="text" :value="value" :required="required" name="test">-->
    <input
        type="text"   class="form-control form-control-sm text-left bg-white"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
        placeholder="---SELECT CATEGORY---"
        :value="selectedText" required
    >
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="z-index: 2000;">
      <li class="dropdown-item text-small pl-1 test bg-lightsilver" @click="selectedItem(null)">
        ---SELECT CATEGORY---
      </li>
      <custom-select-tree :items="items" :children="children"  @click="selectedItem($event)"></custom-select-tree>
    </ul>
  </div>

</template>

<script>
import CustomSelectTree from "@/components/CustomSelectTree";
import {toUpper} from "lodash";
export default {
  name: "CustomSelect",
  components: {CustomSelectTree},
  props: {
    items: {
      type: [Array,Object],
      default : null

    },
    children:{
      type:String,
      default:'children',
    },
    selectionDisplay:{
      type:String,
      default:'',
    },
    selectionTextKey:{
      type:String,
      default:'name',
    },
    returnToParent:{
      type:String,
      default:'id'
    },
    value: {
      default() {
        return null;
      }
    },
    required: {
      type: Boolean,
      default() {
        return false;
      }
    },
  },
  computed:{
    selectedText(){
      if(this.selected){
        let selection = this.findSelection(this.items, this.selected);
        if(selection) {
          return selection[this.selectionTextKey];
        }
      }
      else{
        if(this.item){
          return this.item[this.selectionTextKey];
        }
      }
      return '';
    }
  },
  data(){
    return{
      item:null,
      selected:this.value,
    }
  },
  watch:{
    value() {
      if(this.value){
        this.selected=this.value;
      }
      else{
        this.item=null
        this.selected=null
      }

    }
  },
  methods:{
    selectedItem(item){
      this.item=item
      this.$emit('input',this.item ? this.item[this.returnToParent] : null)

    },
    findSelection(selections, selectedItem) {
      let selectedData = null;
      selections.forEach(selection => {
        if(selection.id == selectedItem) {
          selectedData = selection;
        } else if(selection[this.children] && selection[this.children].length) {
          let locatedSelection = this.findSelection(selection[this.children], selectedItem);
          if(locatedSelection) selectedData = locatedSelection;
        }
      })
      return selectedData;
    },
  }
}
</script>

<style scoped>

</style>
